<template>
  <div>
    <!-- ===================== MOBILE CARD LIST (< 960px) ===================== -->
    <div class="d-md-none damaged-parts-mobile-list mt-2 px-2 pb-4">
      <v-progress-linear v-if="loading" indeterminate color="red" class="mb-2" />

      <div
        v-for="(item, index) in parts"
        :key="item._id"
        class="damaged-parts-mobile-card"
        :class="{
          'damaged-parts-mobile-card--selected': index === activeRow,
        }"
        @click="activeRow = activeRow === index ? null : index"
      >
        <v-btn
          v-if="item.price != null || item.currency"
          color="black"
          variant="outlined"
          size="x-small"
          class="damaged-parts-mobile-card__price"
          readonly
          @click.stop
        >
          {{ item.price }} {{ item.currency }}
        </v-btn>

        <div class="damaged-parts-mobile-card__main">
          <div class="damaged-parts-mobile-card__media">
            <button
              type="button"
              class="damaged-parts-mobile-card__image-btn"
              @click.stop="showImages(item.images)"
            >
              <img
                :src="getPartImageSrc(item)"
                class="damaged-parts-mobile-card__img"
              />
            </button>
            <button
              v-if="getPartQrId(item)"
              type="button"
              class="damaged-parts-mobile-card__qr-btn"
              @click.stop="openPartQr(item)"
            >
              {{ getPartQrId(item) }}
            </button>
          </div>

          <div class="damaged-parts-mobile-card__info">
            <div class="damaged-parts-mobile-card__info-top">
              <v-chip
                v-if="
                  ($store.getters.role === 'LekoAdmin' ||
                    $store.getters.role === 'SuperAdmin') &&
                  item.institution_id?.title
                "
                
                class=" text-xs"
                 size="x-small">
                {{ item.institution_id.title }}
                </v-chip>
              <div
                v-if="item.infoCar?.description?.descriptionId?.group"
                class="text-caption font-weight-bold"
              >
                {{
                  item.infoCar.description.descriptionId.group[
                    $store.getters.language
                  ]
                }}
              </div>
              <div
                v-if="item.infoCar?.description?.descriptionId?.category"
                class="text-caption text-grey-darken-1"
              >
                {{
                  item.infoCar.description.descriptionId.category[
                    $store.getters.language
                  ]
                }}
              </div>
              <div
                v-if="item.infoCar?.description?.descriptionId?.title"
                class="font-weight-bold text-primary text-body-2"
              >
                {{
                  item.infoCar.description.descriptionId.title[
                    $store.getters.language
                  ]
                }}
                <span
                  v-if="item.infoCar?.description?.positionCode"
                  class="text-caption text-grey font-weight-regular"
                >
                  {{ getPosition(item.infoCar.description.positionCode) }}
                </span>
              </div>
            </div>

            <div v-if="item.manufacturer_code" class="text-caption mt-1">
              Cod: <strong>{{ item.manufacturer_code }}</strong>
            </div>
            <div v-if="item.isNewPart" class="mt-1">
              <v-icon size="18" color="success">mdi-check-circle-outline</v-icon>
            </div>
            <div v-if="item.notes" class="text-caption mt-1">
              {{ item.notes }}
            </div>
            <div v-if="item.shelf_data" class="text-caption mt-1">
              {{ item.shelf_data.shelf.room_name }} -
              {{ item.shelf_data.shelf.location_code }}:
              {{ item.shelf_data.shelf.x }}, {{ item.shelf_data.shelf.y }}
              <span class="font-weight-bold ml-1">
                Mag: {{ item.shelf_data.repo }}
              </span>
            </div>
            <div v-if="item.shipment_id?.name" class="text-caption mt-1">
              {{ item.shipment_id.name }}
            </div>
            <div class="text-caption text-grey-darken-1 mt-1">
              {{ formatDate(item.date_created) }}
            </div>
            <div class="mt-1">
              <v-rating
                :model-value="item.quality?.rating || 0"
                color="red"
                readonly
                :size="14"
                density="compact"
              />
            </div>
          </div>
        </div>

        <div class="damaged-parts-mobile-card__actions">
          <v-btn
            v-if="getDamagedStatusMeta(item).label"
            :color="getDamagedStatusMeta(item).color"
            variant="outlined"
            size="x-small"
            class="damaged-parts-mobile-card__status"
            @click.stop="movement(item)"
          >
            {{ getDamagedStatusMeta(item).label }}
          </v-btn>
          <v-spacer />
          <v-btn icon variant="text" size="small" @click.stop="details(item)">
            <v-icon size="20" color="grey-darken-2">mdi-view-list</v-icon>
          </v-btn>
          <v-btn icon variant="text" size="small" @click.stop="actions(item)">
            <v-icon size="20" color="grey-darken-2">
              mdi-compare-horizontal
            </v-icon>
          </v-btn>
        </div>
      </div>

      <v-alert
        v-if="!loading && parts.length < 1"
        type="info"
        variant="tonal"
        class="mt-2"
      >
        No data available.
      </v-alert>
    </div>
    <!-- ===================================================================== -->

    <div class="damaged-parts-table-host pb-2">
      <StickyHScroll>
        <v-data-table-server
        v-model:options="pagination"
        :headers="
          $store.getters.role === 'LekoAdmin' ||
          $store.getters.role === 'SuperAdmin'
            ? headersAdmin
            : headers
        "
        :items="parts"
        :page="pagination.page"
        :items-length="totalItems"
        :loading="loading"
        class="elevation-1 nowrap-headers pb-8"
        :items-per-page="pagination.itemsPerPage"
        :items-per-page-options="[
          { value: 5, title: '5' },
          { value: 10, title: '10' },
          { value: 25, title: '25' },
          { value: 50, title: '50' },
        ]"
        items-per-page-text="Rows per page"
        @update:options="updatePagination"
      >
        <template #progress>
          <v-progress-linear color="red" indeterminate />
        </template>

        <template #item="{ item, index }">
          <tr
            :class="{ tableRowColorSelected: index === activeRow }"
            class="tableRowColor"
            @click="activeRow = activeRow === index ? null : index"
          >
            <!-- OLD ID -->
            <td v-if="item.old_id">
              <v-row
                class="pointer ma-1 text-center justify-center d-block"
                @click.stop="
                  openQrDialog({
                    id: item.old_id,
                    type: 'inventory',
                    printed: item.printed,
                  })
                "
              >
                <qr-code :size="60" :text="item.old_id" />
                {{ item.old_id.slice(-6) }}
              </v-row>
            </td>

            <!-- NEW ID -->
            <td v-else class="text-xs">
              <v-row
                class="pointer ma-1 text-center justify-center d-block"
                @click.stop="
                  openQrDialog({
                    id: item._id,
                    type: 'inventory',
                    printed: item.printed,
                  })
                "
              >
                <qr-code :size="60" :text="item._id" />
                {{ item._id.slice(-4) }}
              </v-row>
            </td>

            <!-- ACTIONS -->
            <td>
              <v-row class="d-block justify-center text-center">
                <v-btn icon variant="text" @click.stop="details(item)">
                  <v-icon color="grey-darken-2"> mdi-view-list </v-icon>
                </v-btn>
                <v-btn icon variant="text" @click.stop="actions(item)">
                  <v-icon color="grey-darken-2">
                    mdi-compare-horizontal
                  </v-icon>
                </v-btn>
              </v-row>
            </td>

            <!-- LEKO GROUP -->
            <td>
              <span
                v-if="
                  item.infoCar.description &&
                  item.infoCar.description.descriptionId &&
                  item.infoCar.description.descriptionId.group
                "
                class="text-xs font-weight-bold"
              >
                {{
                  item.infoCar.description.descriptionId.group[
                    $store.getters.language
                  ]
                }}
              </span>
            </td>

            <!-- GROUP -->
            <td>
              <span
                v-if="
                  item.infoCar.description &&
                  item.infoCar.description.descriptionId &&
                  item.infoCar.description.descriptionId.category
                "
                class="text-xs font-weight-bold"
              >
                {{
                  item.infoCar.description.descriptionId.category[
                    $store.getters.language
                  ]
                }}
              </span>
            </td>

            <!-- TITLE -->
            <td class="text-xs">
              <span
                v-if="
                  item.infoCar.description &&
                  item.infoCar.description.descriptionId &&
                  item.infoCar.description.descriptionId.title
                "
                class="text-xs font-weight-bold"
              >
                {{
                  item.infoCar.description.descriptionId.title[
                    $store.getters.language
                  ]
                }}
              </span>
              <span
                v-if="
                  item.infoCar.description &&
                  item.infoCar.description.positionCode
                "
                class="text-xs"
              >
                {{
                  item.infoCar.description.positionCode
                    ? getPosition(item.infoCar.description.positionCode)
                    : ""
                }}
              </span>
            </td>

            <!-- MANUFACTURER CODE -->
            <td class="text-xs">
              {{ item.manufacturer_code }}
            </td>

            <!-- INSTITUTION -->
            <td
              v-if="
                ($store.getters.role === 'LekoAdmin' ||
                  $store.getters.role === 'SuperAdmin') &&
                item.institution_id
              "
              class="text-xs"
            >
              <v-chip>
                {{ item.institution_id.title }}
              </v-chip>
            </td>
            <td
              v-else-if="
                $store.getters.role === 'LekoAdmin' ||
                $store.getters.role === 'SuperAdmin'
              "
            />

            <!-- IMAGES -->
            <td>
              <v-row class="justify-center text-center">
                <img
                  :src="
                    item.images && item.images.length > 0
                      ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.images[0].thumb}`
                      : 'https://portal.lekotech.com/logo_small.png'
                  "
                  class="ma-1 pointer"
                  height="75"
                  width="100"
                  @click.stop="showImages(item.images)"
                />
              </v-row>
            </td>

            <!-- CONDITION -->
            <td class="text-xs">
              <v-icon v-if="item.isNewPart"> mdi-check-circle-outline </v-icon>
            </td>

            <!-- NOTES -->
            <td class="text-xs">
              {{ item.notes }}
            </td>

            <!-- PRICE -->
            <td class="text-xs">{{ item.price }} {{ item.currency }}</td>

            <!-- LOCATION -->
            <td v-if="item.shelf_data" class="text-xs">
              <span>
                {{ item.shelf_data.shelf.room_name }} -
                {{ item.shelf_data.shelf.location_code }}:
                {{ item.shelf_data.shelf.x }},
                {{ item.shelf_data.shelf.y }}
              </span>
              <div class="text-no-wrap">
                <span class="caption">Mag: </span>
                <span class="font-weight-bold caption">{{
                  item.shelf_data.repo
                }}</span>
              </div>
            </td>
            <td v-else class="text-xs">-</td>

            <!-- SHIPMENT -->
            <td>{{ item.shipment_id.name || "-" }}</td>

            <!-- QUALITY -->
            <td class="text-center justify-center">
              <v-rating
                v-if="item.quality"
                :model-value="item.quality.rating"
                color="red"
                background-color="red-darken-4"
                readonly
                :size="16"
              />
              <v-rating
                v-else
                :model-value="0"
                color="red"
                background-color="red-darken-4"
                readonly
                :size="16"
              />
              <!-- </td> -->

              <!-- DATE & STATUS -->
              <!-- <td class="pt-2 pb-1"> -->
              <div class="text-center text-truncate pb-2">
                {{ formatDate(item.date_created) }}
              </div>
              <v-row justify="center" class="pt-3 mb-1">
                <v-btn
                  v-if="item.status === 7"
                  small
                  color="amber"
                  variant="outlined"
                  @click.stop="movement(item)"
                >
                  {{ $t("parts.status.damaged_inventory") }}
                </v-btn>
                <v-btn
                  v-if="item.status === 8"
                  small
                  color="amber"
                  variant="outlined"
                  @click.stop="movement(item)"
                >
                  {{ $t("parts.status.damaged_sales") }}
                </v-btn>
                <v-btn
                  v-if="item.status === 8.1"
                  small
                  color="amber"
                  variant="outlined"
                  @click.stop="movement(item)"
                >
                  {{ $t("parts.status.damaged_shop") }}
                </v-btn>
                <v-btn
                  v-if="item.status === 9"
                  small
                  color="amber"
                  variant="outlined"
                  @click.stop="movement(item)"
                >
                  {{ $t("parts.status.damaged_lost") }}
                </v-btn>
              </v-row>
            </td>
          </tr>
          <tr v-if="parts && parts.length < 1">
            <td :colspan="headers.length" class="text-center pa-4">
              <v-alert type="info" border="left" color="red lighten-2" text>
                No data available.
              </v-alert>
            </td>
          </tr>
        </template>
      </v-data-table-server>
      </StickyHScroll>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueQrCode from "vue-qr-generator";
import getRequest from "../../api/getRequest";
let lastRequestId = 0;
export default {
  components: {
    "qr-code": VueQrCode,
  },
  props: ["search"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    loading: false,
    activeRow: null,
    pagination: {
      itemsPerPage: 5,
      page: 1,
      groupBy: ["date_created"],
      sortBy: [{ key: "date_created", order: "desc" }],
      sortDesc: [true],
    },
    totalItems: 0,
    parts: [],
    headers: [
      {
        title: "",
        sortable: true,
        key: "_id",
      },
      {
        title: "",
        sortable: false,
        key: "actions",
      },
      {
        title: "",
        sortable: true,
        key: "leko_group",
      },
      {
        title: "",
        sortable: true,
        key: "group",
      },
      {
        title: "",
        sortable: true,
        key: "title",
      },
      {
        title: "",
        sortable: false,
        key: "manufacturer_code",
      },
      {
        title: "",
        sortable: false,
        key: "images",
      },
      {
        title: "",
        sortable: false,
        key: "isNewPart",
      },
      {
        title: "",
        sortable: false,
        key: "notes",
      },
      {
        title: "",
        sortable: true,
        key: "price",
      },
      {
        title: "",
        sortable: true,
        key: "shelf_data.shelf.room_name",
      },
      {
        title: "",
        sortable: true,
        key: "shipment_id",
      },
      // {
      //   text: '',
      //   sortable: true,
      //   value: 'quality',
      // },
      // {
      //   text: '',
      //   sortable: true,
      //   value: 'date_created',
      // },
      {
        title: "",
        sortable: true,
        key: "date_created",
      },
    ],
    headersAdmin: [
      {
        title: "",
        sortable: true,
        key: "_id",
      },
      {
        title: "",
        sortable: false,
        key: "actions",
      },
      {
        title: "",
        sortable: true,
        key: "leko_group",
      },
      {
        title: "",
        sortable: true,
        key: "group",
      },
      {
        title: "",
        sortable: true,
        key: "title",
      },
      {
        title: "",
        sortable: false,
        key: "manufacturer_code",
      },
      {
        title: "",
        sortable: false,
        key: "institution_id",
      },
      {
        title: "",
        sortable: false,
        key: "",
      },
      {
        title: "",
        sortable: false,
        key: "isNewPart",
      },
      {
        title: "",
        sortable: false,
        key: "notes",
      },
      {
        title: "",
        sortable: true,
        key: "price",
      },
      {
        title: "",
        sortable: true,
        key: "shelf_data.shelf.room_name",
      },
      {
        title: "",
        sortable: true,
        key: "shipment_id",
      },
      // {
      //   text: '',
      //   sortable: true,
      //   value: 'quality',
      // },
      {
        title: "",
        sortable: true,
        key: "date_created",
      },
      // {
      //   text: '',
      //   sortable: true,
      //   value: 'status',
      // },
    ],
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    searchObject() {
      return this.$props.search;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.searchObject.type === null) {
          this.getParts();
        } else if (this.searchObject.type === "regularSearch") {
          this.regularSearch(this.searchObject.data);
        } else if (this.searchObject.type === "advancedSearch") {
          this.advancedSearch(this.searchObject.data);
        } else {
          //
        }
      },
      deep: true,
    },
    searchObject: {
      handler(value) {
        if (value.type === null) {
          this.getParts();
        } else if (value.type === "regularSearch") {
          this.regularSearch(value.data);
        } else if (value.type === "advancedSearch") {
          this.advancedSearch(value.data);
        } else {
          //
        }
      },
    },
    parts(value) {
      this.$emit("items", value);
    },
    "$i18n.locale"() {
      this.getLocale();
    },
  },
  beforeMount() {
    this.getLocale();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t("parts.table.qr_code");
      this.headers[1].title = this.$t("parts.table.actions");
      this.headers[2].title = this.$t("parts.table.leko_group");
      this.headers[3].title = this.$t("parts.table.group");
      this.headers[4].title = this.$t("parts.table.title");
      this.headers[5].title = this.$t("parts.table.manufacturer_code");
      this.headers[6].title = this.$t("parts.table.images");
      this.headers[7].title = this.$t("parts.table.new");
      this.headers[8].title = this.$t("parts.table.notes");
      this.headers[9].title = this.$t("parts.table.price");
      this.headers[10].title = this.$t("parts.table.location");
      this.headers[11].title = this.$t("parts.table.shipment");
      // this.headers[11].text = this.$t('parts.table.quality');
      this.headers[12].title = this.$t("parts.table.date_created");
      // this.headers[11].text = this.$t('parts.table.status');
      this.headersAdmin[0].title = this.$t("parts.table.qr_code");
      this.headersAdmin[1].title = this.$t("parts.table.actions");
      this.headersAdmin[2].title = this.$t("parts.table.leko_group");
      this.headersAdmin[3].title = this.$t("parts.table.group");
      this.headersAdmin[4].title = this.$t("parts.table.title");
      this.headersAdmin[5].title = this.$t("parts.table.manufacturer_code");
      this.headersAdmin[6].title = this.$t("parts.table.institution");
      this.headersAdmin[7].title = this.$t("parts.table.images");
      this.headersAdmin[8].title = this.$t("parts.table.new");
      this.headersAdmin[9].title = this.$t("parts.table.notes");
      this.headersAdmin[10].title = this.$t("parts.table.price");
      this.headersAdmin[11].title = this.$t("parts.table.location");
      this.headersAdmin[12].title = this.$t("parts.table.shipment");
      // this.headersAdmin[12].text = this.$t('parts.table.quality');
      this.headersAdmin[13].title = this.$t("parts.table.date_created");
      // this.headersAdmin[12].text = this.$t('parts.table.status');
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
    getParts() {
      const requestId = ++lastRequestId;
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part/damaged/datatable",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${sort.order === "desc"}`,
      )
        .then((response) => {
          if (requestId !== lastRequestId) return;
          this.$scrollToTop();
          this.totalItems = response.count;
          this.parts = response.parts;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    regularSearch(data) {
      const requestId = ++lastRequestId;
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part/damaged/search/regular",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${
          sort.order === "desc"
        }&search_field=${data.searchField}&title_code=${
          data.titleCode
        }&title_codes=${data.titleCodes}&type=${
          data.type
        }&language=${this.$store.getters.language}`,
      )
        .then((response) => {
          if (requestId !== lastRequestId) return;
          this.$scrollToTop();
          this.totalItems = response.count;
          this.parts = response.parts;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    advancedSearch(data) {
      const requestId = ++lastRequestId;
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date_created",
        order: "desc",
      };
      getRequest(
        "/part/damaged/search/advanced",
        `institution_id=${this.$store.getters.institutionId}&role=${
          this.$store.getters.role
        }&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${
          sort.order === "desc"
        }&search_field=${data.searchField}&language=${
          this.$store.getters.language
        }&title_code=${data.titleCode}&title_codes=${data.titleCodes}&type=${
          data.type
        }&brand=${data.advancedSearchFields.brand}&model=${
          data.advancedSearchFields.model
        }&version=${data.advancedSearchFields.version}&institution=${
          data.advancedSearchFields.institution
        }&shipment=${data.advancedSearchFields.shipment}&status=${
          data.advancedSearchFields.status
        }&quality=${data.advancedSearchFields.quality}&price=${
          data.advancedSearchFields.price
        }&start_date=${
          data.advancedSearchFields.startDate
        }&end_date=${data.advancedSearchFields.endDate}`,
      )
        .then((response) => {
          if (requestId !== lastRequestId) return;
          this.$scrollToTop();
          this.totalItems = response.count;
          this.parts = response.parts;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    actions(data) {
      this.$emit("actions", data);
    },
    details(data) {
      this.$emit("details", data);
    },
    movement(data) {
      this.$emit("movement", data);
    },
    openQrDialog(data) {
      this.$emit("qr", data);
    },
    showImages(images) {
      this.$emit("images", { type: "string", images });
    },
    updatePagination(options) {
      this.pagination = {
        ...options,
        itemsPerPage: options.itemsPerPage ? options.itemsPerPage : 5,
        groupBy:
          options.groupBy && options.groupBy.length
            ? options.groupBy
            : ["date_created"],
        sortBy:
          options.sortBy && options.sortBy.length
            ? options.sortBy
            : { key: "date_created", order: "desc" },
        sortDesc:
          options.sortDesc && options.sortDesc.length
            ? options.sortDesc
            : [true],
      };
      this.activeRow = null;
    },
    getPosition(code) {
      switch (code) {
        case "S001":
          return this.$t("left");
        case "S002":
          return this.$t("right");
        default:
          return "";
      }
    },
    getPartQrId(item) {
      if (item.old_id) {
        return item.old_id.slice(item.old_id.length - 6, item.old_id.length);
      }
      if (item._id) {
        return item._id.slice(item._id.length - 4, item._id.length);
      }
      return "";
    },
    openPartQr(item) {
      if (item.old_id) {
        this.openQrDialog({
          id: item.old_id,
          type: "inventory",
          printed: item.printed,
        });
      } else {
        this.openQrDialog({
          id: item._id,
          type: "inventory",
          printed: item.printed,
        });
      }
    },
    getPartImageSrc(item) {
      if (item.images?.length > 0 && item.images[0].thumb) {
        return `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.images[0].thumb}`;
      }
      return "https://portal.lekotech.com/logo_small.png";
    },
    getDamagedStatusMeta(item) {
      if (item.status === 7) {
        return {
          label: this.$t("parts.status.damaged_inventory"),
          color: "amber",
        };
      }
      if (item.status === 8) {
        return {
          label: this.$t("parts.status.damaged_sales"),
          color: "amber",
        };
      }
      if (item.status === 8.1) {
        return {
          label: this.$t("parts.status.damaged_shop"),
          color: "amber",
        };
      }
      if (item.status === 9) {
        return {
          label: this.$t("parts.status.damaged_lost"),
          color: "amber",
        };
      }
      return { label: "", color: "grey" };
    },
  },
};
</script>

<style scoped>
@media (max-width: 959.98px) {
  .damaged-parts-table-host :deep(.v-table__wrapper),
  .damaged-parts-table-host :deep(.v-data-table__wrapper),
  .damaged-parts-table-host :deep(.v-data-table__wrapper__scroll) {
    display: none !important;
  }
  .damaged-parts-table-host :deep(.global-sticky-hscroll) {
    display: none !important;
  }
  .damaged-parts-table-host :deep(.v-data-table-footer) {
    padding-inline: 12px;
  }
}
@media (min-width: 960px) {
  .damaged-parts-mobile-list {
    display: none !important;
  }
}

.damaged-parts-mobile-card {
  position: relative;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.damaged-parts-mobile-card__price {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 1;
  font-size: 0.7rem !important;
  max-width: 55%;
  height: auto !important;
  min-height: 0 !important;
  text-transform: none;
  letter-spacing: normal;
}
.damaged-parts-mobile-card--selected {
  outline: 2px solid rgb(var(--v-theme-primary));
}
.damaged-parts-mobile-card__main {
  display: flex;
  align-items: flex-start;
  padding: 8px;
  gap: 8px;
}
.damaged-parts-mobile-card__media {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.damaged-parts-mobile-card__image-btn {
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.damaged-parts-mobile-card__img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 4px;
  background: #212121;
  display: block;
}
.damaged-parts-mobile-card__qr-btn {
  min-width: 72px;
  padding: 4px 8px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  background: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  color: #424242;
  cursor: pointer;
  text-align: center;
}
.damaged-parts-mobile-card__info {
  flex: 1;
  min-width: 0;
}
.damaged-parts-mobile-card__info-top {
  padding-right: 88px;
}
.damaged-parts-mobile-card__status {
  flex-shrink: 1;
  height: auto !important;
  min-height: 0 !important;
  font-size: 0.65rem !important;
  text-transform: none;
  letter-spacing: normal;
  max-width: 55%;
}
.damaged-parts-mobile-card__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding: 4px 6px;
}
</style>
